import { ActionCard } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { RouterService } from '@cortex-shim/router.service';
import { useResolve } from '@visiba/instantiation';
import styled from 'styled-components';
import { useViewFindReceptionTempNavigationContext } from '../_temp_navigation.context';
import { ReceptionBrowserReceptionModel } from './browse_receptions.controller';

interface ReceptionListProps {
	receptions: ReceptionBrowserReceptionModel[];
}

export function ReceptionList({ receptions }: ReceptionListProps) {
	const routerService = useResolve(RouterService);
	const { __TEMP__onNavigate } = useViewFindReceptionTempNavigationContext();

	if (receptions.length === 0) {
		return null;
	}

	function handleOnReceptionClick(reception: ReceptionBrowserReceptionModel) {
		if (__TEMP__onNavigate) {
			__TEMP__onNavigate(`${reception.route}`);
			return;
		}

		routerService.navigateByUrl(`${reception.route}`);
	}

	return (
		<StyledGrid>
			{receptions.map((reception) => (
				<ActionCardContainer key={reception.receptionId}>
					<ActionCard.Root key={reception.receptionId} onClick={() => handleOnReceptionClick(reception)} icon='house'>
						<ActionCard.Title>{reception.name}</ActionCard.Title>
						{reception.description ? <ActionCard.Meta>{reception.description}</ActionCard.Meta> : null}
					</ActionCard.Root>
				</ActionCardContainer>
			))}
		</StyledGrid>
	);
}

const ActionCardContainer = styled.div`
	display: flex;
	width: 100%;
`;

export const StyledGrid = styled.div`
	display: flex;
	direction: column;
	flex-wrap: wrap;
	gap: ${tokens.spacing.x1};

	${tokens.breakpointQuery.medium} {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: ${tokens.spacing.x2};
	}

	${tokens.breakpointQuery.large} {
		grid-template-columns: 1fr 1fr 1fr;
	}
`;
